import React, { FC } from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Bojenje po brojevima";
const SITE_URL = "https://bojenjepobrojevima.rs";
const DEFAULT_IMAGE = `${SITE_URL}/assets/img/start/bpb_start_01.jpg`;

interface SeoProps {
  /** Page title. " | Bojenje po brojevima" is appended automatically unless this is the home page. */
  title: string;
  description: string;
  /** Path part of the canonical URL, e.g. "/o-nama". Defaults to "/". */
  path?: string;
  /** Absolute or site-relative image URL for social sharing. */
  image?: string;
  /** Set true on the home page so the title isn't suffixed with the site name. */
  isHome?: boolean;
}

const Seo: FC<SeoProps> = ({ title, description, path = "/", image, isHome }) => {
  const fullTitle = isHome ? title : `${title} | ${SITE_NAME}`;
  const url = `${SITE_URL}${path}`;
  const img = image
    ? image.startsWith("http")
      ? image
      : `${SITE_URL}${image.startsWith("/") ? "" : "/"}${image}`
    : DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
